<template>
  <el-dialog title="客服列表" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
    <div class="input-box">
      <el-input v-model="inputVal" placeholder="搜索" prefix-icon="el-icon-search"></el-input>
      <el-button type="primary" size="small">搜索</el-button>
    </div>
    <div class="list-box">
      <div class="list" v-for="(item,index) in serviceOptions" :key="index" :class="{'active': item.active}" @click="handleSure(item)">
        <img src="http://freesaasofficedata.oss.aliyuncs.com/verified/20221114171650245.jpg" />
        <span>{{item.realName}} {{item.mobile}}</span>
        <!-- workStatus  在线 10 离线 20 离开 30-->
        <el-button type="success" size="mini" round v-if="item.workStatus === 10">在线</el-button>
        <el-button type="info" size="mini" round v-if="item.workStatus === 20">离线</el-button>
        <el-button type="danger" size="mini" round v-if="item.workStatus === 30">离开</el-button>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import custServiceStaffApi from '@/api/customer/custServiceStaff'
import imConversationApi from '@/api/customer/imConversation'
export default {
  props: ['currentUser'],
  data() {
    return {
      form: null,
      formVisible: false,
      serviceOptions: [],
      inputVal: '',
      rowItem: null
    }
  },
  created() {

  },
  methods: {
    handleShow(serviceInfo) {
      this.getServiceList(serviceInfo)
    },
    getServiceList(serviceInfo) {
      custServiceStaffApi.fetchForList({ realName: this.inputVal }).then(({ data }) => {
        // 过滤掉当前客服的数据
        this.serviceOptions = data.filter(item => item.id !== serviceInfo.id)
        this.formVisible = true
      })
    },
    handleSure(item) {
      this.rowItem = item
      this.serviceOptions.forEach(itt => {
        itt.active = itt.id === item.id ? true : false
      })
      this.$forceUpdate();
    },
    doCreate() {
      imConversationApi.transferForKeFu({ id: this.currentUser.id, fromUserInfoId: this.rowItem.id }).then(res => {
        this.formVisible = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.input-box {
  display: flex;
  align-items: center;
  justify-content: center;
  .el-button {
    margin: 0 10px;
  }
}
.list-box {
  margin-top: 20px;
  .list {
    display: flex;
    align-items: center;
    padding: 8px 10px;
    cursor: pointer;
    img {
      width: 46px;
      height: 46px;
      border-radius: 50%;
    }
    span {
      font-size: 16px;
      padding: 0 120px 0 10px;
    }
    &:hover {
      background: rgba(197, 197, 197, 0.3);
    }
    &.active {
      background: rgba(21, 150, 205, 0.1);
      span {
        color: #1596cd;
      }
    }
  }
}
</style>
